package devxertech.com.pages.dashboard.teamOfferSection

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextTransform
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.css.functions.LinearGradient
import com.varabyte.kobweb.compose.css.functions.linearGradient
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.backgroundImage
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.letterSpacing
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onMouseEnter
import com.varabyte.kobweb.compose.ui.modifiers.onMouseLeave
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.textTransform
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Constants
import devxertech.com.utils.Res
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.whiteSpace


@Composable
fun TeamOfferSection() {
    val breakpoint = rememberBreakpoint()
    val sitePalette = ColorMode.current.toSitePalette()
    var activeId by remember { mutableStateOf("") }

    DisposableEffect(Unit) {
        val onScroll: (org.w3c.dom.events.Event) -> Unit = {
            listOf(
                "team-1","team-2","team-3",
                "team-4","team-5","team-6"
            ).forEach { id ->
                val el = document.getElementById(id) ?: return@forEach
                val rect = el.getBoundingClientRect()
                if (rect.top in 0.0..300.0) {
                    activeId = id
                }
            }
        }

        window.addEventListener("scroll", onScroll)
        onDispose { window.removeEventListener("scroll", onScroll) }
    }

    Box(
        modifier = Modifier
            .fillMaxWidth()
            .margin(topBottom = 30.px)
            .padding(topBottom = if (breakpoint < Breakpoint.MD) 20.px else 40.px)
            ,
        contentAlignment = Alignment.Center
    ) {
        Column(
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            SpanText(
                text = "Why Choose Us?",
                modifier = Modifier
                    .fontFamily(Constants.FONT_FAMILY)
                    .fontSize(18.px)
                    .color(sitePalette.commonSecondaryButtonColor.rgb)
                    .fontWeight(FontWeight.Medium)
                    .lineHeight(15.4.px)
                    .textTransform(TextTransform.Uppercase)
                    .padding(bottom = 10.px) // Optional spacing between texts
            )

            // Split the sentence for different color styles
            Row(
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.Center
            ) {
                SpanText(
                    text = "What Our ",
                    modifier = Modifier
                        .fontFamily(Constants.ROBOTO_FONT)
                        .fontSize(if(breakpoint > Breakpoint.MD)35.px else 20.px)
                        .color(sitePalette.commonSecondaryButtonColor.rgb) // Secondary color for regular text
                        .fontWeight(FontWeight.ExtraBold)
                        .lineHeight(37.4.px)
                        .letterSpacing(0.5.px)
                        .textTransform(TextTransform.Uppercase)
                )
                SpanText(
                    text = "Team",
                    modifier = Modifier
                        .fontFamily(Constants.ROBOTO_FONT)
                        .fontSize(if(breakpoint > Breakpoint.MD)35.px else 20.px)
                        .color(sitePalette.primary.rgb) // Primary color for "Team"
                        .fontWeight(FontWeight.ExtraBold)
                        .lineHeight(37.4.px)
                        .letterSpacing(0.5.px)
                        .textTransform(TextTransform.Uppercase)
                )
                SpanText(
                    text = " Can Offer",
                    modifier = Modifier
                        .fontFamily(Constants.ROBOTO_FONT)
                        .fontSize(if(breakpoint > Breakpoint.MD)35.px else 20.px)
                        .color(sitePalette.commonSecondaryButtonColor.rgb) // Secondary color for regular text
                        .fontWeight(FontWeight.ExtraBold)
                        .lineHeight(37.4.px)
                        .letterSpacing(0.5.px)
                        .textTransform(TextTransform.Uppercase)
                )
            }

            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(top = if(breakpoint < Breakpoint.MD) 20.px else 50.px)
                    .margin(leftRight = 10.px).flexWrap(FlexWrap.Wrap),
                horizontalArrangement = Arrangement.Center
            ) {
                TeamService(
                    id = "team-1",
                    activeId = activeId,
                    image = Res.Image.innovation_Solution,
                    hoverImage = Res.Image.innovation_Solution_white,
                    title = "Innovative Solutions",
                    description = "We stay ahead of the curve by leveraging the latest " +
                            "technologies and trends to deliver cutting-edge " +
                            "solutions.",

                    )
                TeamService(
                    id = "team-2",
                    activeId = activeId,
                    image = Res.Image.trace_record,
                    hoverImage = Res.Image.trace_record_white,
                    title = "Proven Track Record",
                    description = "With a history of delivering high-quality projects on" +
                            "time and within budget, we pride ourselves on " +
                            "being a trusted partner for our clients.",

                    )
                TeamService(
                    id = "team-3",
                    activeId = activeId,
                    image = Res.Image.experienced_team,
                    hoverImage = Res.Image.experienced_team_white,
                    title = "Experienced Team",
                    description = "Our team consists of industry experts with years of " +
                            "experience in IT strategy, development, and " +
                            "implementation to deliver diverse results.",

                    )
                if(window.screen.width < 1600 ){
                    TeamService(
                        id = "team-4",
                        activeId = activeId,
                        image = Res.Image.scalable_Solution,
                        hoverImage = Res.Image.scalable_Solution_white,
                        title = "Scalable Solutions",
                        description = "   Our solutions grow with you. Whether you’re a\nstartup or an established enterprise, we design it " +
                                "systems that are flexible and scalable.",

                        )
                    TeamService(
                        id = "team-5",
                        activeId = activeId,
                        image = Res.Image.customer_centric,
                        hoverImage = Res.Image.customer_centric_white,
                        title = "Customer-Centric Approach",
                        description = "Your success is our priority.We believe in personalized service ensuring that our solutions are " +
                                "aligned with your goals.",

                        )
                    TeamService(
                        id = "team-6",
                        activeId = activeId,
                        image = Res.Image.support,
                        hoverImage = Res.Image.support_white,
                        title = "There for Support",
                        description = "We offer around-the-clock support.Whether you need " +
                                "immediate assistance or long-term maintenance, " +
                                "our support team is always ready to help.",

                        )
                }}
            if(window.screen.width > 1600){
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(top = 50.px)
                        .margin(leftRight = 60.px).display(DisplayStyle.Flex).flexWrap(FlexWrap.Wrap),
                    horizontalArrangement = Arrangement.Center
                ) {
                    TeamService(
                        id = "team-4",
                        activeId = activeId,
                        image = Res.Image.scalable_Solution,
                        hoverImage = Res.Image.scalable_Solution_white,
                        title = "Scalable Solutions",
                        description = "   Our solutions grow with you. Whether you’re a\nstartup or an established enterprise, we design it " +
                                "systems that are flexible and scalable.",

                        )
                    TeamService(
                        id = "team-5",
                        activeId = activeId,
                        image = Res.Image.customer_centric,
                        hoverImage = Res.Image.customer_centric_white,
                        title = "Customer-Centric Approach",
                        description = "Your success is our priority.We believe in personalized service ensuring that our solutions are " +
                                "aligned with your goals.",

                        )
                    TeamService(
                        id = "team-6",
                        activeId = activeId,
                        image = Res.Image.support,
                        hoverImage = Res.Image.support_white,
                        title = "There for Support",
                        description = "We offer around-the-clock support.Whether you need " +
                                "immediate assistance or long-term maintenance, " +
                                "our support team is always ready to help.",
                        )
                }
            }
        }
    }
}

@Composable
fun TeamService(id: String,image: String, hoverImage: String, title: String, description: String,  activeId: String) {
    val breakpoint = rememberBreakpoint()
    val sitePalette = ColorMode.current.toSitePalette()
    var isHovered by remember { mutableStateOf(false) }
    val highlight = isHovered || (activeId == id && breakpoint <= Breakpoint.MD)

    Box(
        modifier = Modifier
            .id(id)
            .width(
                when {
                    breakpoint > Breakpoint.MD -> 413.px
                    window.screen.width in 952..1350 -> 200.px
                    breakpoint == Breakpoint.MD -> 340.px
                    else -> 270.px
                }
            )
            .height(256.px)
            .margin(topBottom = 20.px, leftRight = 15.px)
            .then(
                if (highlight)
                    Modifier.backgroundImage(
                        linearGradient(
                            LinearGradient.Direction.ToRight,
                            sitePalette.hoverGradientTeam.rgb,
                            sitePalette.hoverGradientOne.rgb
                        )
                    )
                else
                    Modifier.backgroundColor(Colors.White)
            )
            .borderRadius(11.px)
            .boxShadow(blurRadius = 49.px, spreadRadius = (-9).px, color = Colors.LightGray)
            .onMouseEnter { isHovered = true }
            .onMouseLeave { isHovered = false },
        contentAlignment = Alignment.Center
    )
 {
        Column(
            modifier = Modifier
                .margin(bottom = 10.px),
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Image(
                src = if (highlight) hoverImage else image,
                modifier = Modifier
                    .width(85.56.px)
                    .height(76.5.px)
                    .margin(bottom = 10.px)

            )
            SpanText(
                title, modifier = Modifier
                    .fontFamily(Constants.ROBOTO_FONT)
                    .fontSize(18.px)
                    .textAlign(TextAlign.Center)
                    .color(sitePalette.commonSecondaryButtonColor.rgb)
                    .color(if (highlight) Colors.White else sitePalette.commonSecondaryButtonColor.rgb)
                    .fontWeight(FontWeight.Bold)
                    .lineHeight(if (title == "Customer-Centric Approach" && breakpoint < Breakpoint.MD) 24.4.px else 37.4.px)
                    .padding(bottom = if (title == "Customer-Centric Approach" && breakpoint < Breakpoint.MD) 8.px else 0.px)
                    .margin(top = if (title == "Customer-Centric Approach" && breakpoint < Breakpoint.MD) (-7).px else 0.px)
                    .letterSpacing(0.5.px)
                    .textTransform(TextTransform.Uppercase)


            )
            SpanText(
                description,
                modifier = Modifier
                    .fontFamily(Constants.FONT_FAMILY)
                    .fontSize(14.px)
                    .color(sitePalette.commonSecondaryButtonColor.rgb)
                    .fontWeight(if (isHovered) FontWeight.Lighter else FontWeight.Normal)
                    .lineHeight(20.4.px)
//                    .margin(left = 35.px)
                    .padding(leftRight = if (breakpoint < Breakpoint.MD) 20.px else 27.px)
                    .textAlign(TextAlign.Center)
                    .whiteSpace(WhiteSpace.PreWrap)
                    .styleModifier { whiteSpace("pre-wrap") }
                    .color(if (highlight) Colors.White else sitePalette.commonSecondaryButtonColor.rgb)
            )
        }
    }
}